__turbopack_context__.v({
  "blink": "ResultHeader-module-scss-module__i8XMva__blink",
  "fade-in": "ResultHeader-module-scss-module__i8XMva__fade-in",
  "fade-up": "ResultHeader-module-scss-module__i8XMva__fade-up",
  "headline": "ResultHeader-module-scss-module__i8XMva__headline",
  "isLoading": "ResultHeader-module-scss-module__i8XMva__isLoading",
  "loading": "ResultHeader-module-scss-module__i8XMva__loading",
  "root": "ResultHeader-module-scss-module__i8XMva__root",
  "subhead": "ResultHeader-module-scss-module__i8XMva__subhead",
});
